/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ShopCouponListPage = lazyLoad(
  () => import('./index'),
  module => module.ShopCouponListPage
);
